module.exports = __webpack_public_path__ + "id.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/id.svg
// module id = 603
// module chunks = 0